import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import TimePicker from "../../../../Input/TimePicker";
import { jsx as _jsx } from "react/jsx-runtime";
function TimePickerCell(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(TimePicker, _extends({}, props, {
    ref: null
  }));
}
export default TimePickerCell;